import { useSpring } from "react-spring";
import { InputBaseProps } from "@mui/material";
import React from "react";
import {
	CustomInputBase,
	CustomInputBaseProps,
	CustomInputTitle,
	CustomInputWrapper,
	InputButton,
	InputButtonCancel,
	InputButtonWrapper,
	InputErrorText,
} from "./style";

interface InputProps extends InputBaseProps, CustomInputBaseProps {
	titleText?: string;
	maxLength?: number;
	digits?: boolean;
	marginBottom?: number;
	onClickSubmit?: () => void;
	onClickCancel?: () => void;
	showExtraButton?: boolean;
	errorText?: string;
}
export default function Input({
	titleText,
	sidePadding = 16,
	fullWidth = true,
	onChange,
	maxLength,
	digits,
	rows,
	marginBottom,
	showExtraButton,
	onClickSubmit,
	onClickCancel,
	errorText,
	...args
}: InputProps) {
	const handleChange: React.ChangeEventHandler<
		HTMLTextAreaElement | HTMLInputElement
	> = (e) => {
		const value = e.target.value;
		const digitsReg = new RegExp("^[0-9]+$");
		if (!onChange) {
			return;
		}
		if (digits && !digitsReg.test(value)) {
			e.target.value = value.substring(0, value.length - 1);
		}
		if (maxLength && value.length > maxLength) {
			e.target.value = value.substring(0, maxLength);
		}
		onChange(e);
	};

	const slideDown = useSpring({
		opacity: showExtraButton && args.value ? 1 : 0,
		height: showExtraButton && args.value ? "34px" : "0",
		display: showExtraButton && args.value && "flex",
		enter: {
			display: "none",
		},
		leave: {
			display: "none",
		},
		clamp: true,
		config: {
			duration: 150,
		},
	});

	return (
		<CustomInputWrapper marginBottom={marginBottom}>
			{titleText && <CustomInputTitle>{titleText}</CustomInputTitle>}
			<CustomInputBase
				fullWidth={fullWidth}
				sidePadding={sidePadding}
				onChange={handleChange}
				multiline={Boolean(rows)}
				minRows={rows}
				autoComplete="off"
				error={Boolean(errorText)}
				{...args}
			/>
			{errorText && <InputErrorText>{errorText}</InputErrorText>}
			<InputButtonWrapper style={slideDown}>
				{onClickCancel && (
					<InputButtonCancel
						variant="contained"
						backgroundColor="#fff"
						onClick={onClickCancel}
					>
						취소
					</InputButtonCancel>
				)}
				{onClickSubmit && (
					<InputButton
						variant="contained"
						backgroundColor="#0071E3"
						onClick={onClickSubmit}
					>
						변경
					</InputButton>
				)}
			</InputButtonWrapper>
		</CustomInputWrapper>
	);
}
